import React from 'react';

import './EditPanelLegend.css';

const EditPanelLegend = ({ children }) => <legend className="EditPanelLegend">{children}</legend>;

export default EditPanelLegend;
